import ApplicationMetadata from 'components/ApplicationMetadata/ApplicationMetadata';
import { PeachCollectorLoaded } from 'frontend/lib/peach';
import 'frontend/polyfills';
import { ThemeProvider } from 'next-themes';
import Script from 'next/script';
import { FC } from 'react';
import '../components/Player/jwStyles/skin.css';
import '../styles/globals.css';
import { AppProps } from 'next/app';
import SessionProviderWithFeatureFlag from 'components/SessionProviderWithFeatureFlag/SessionProviderWithFeatureFlag';
import FeatureFlagProvider from 'components/FeatureFlagProvider/FeatureFlagProvider';
interface FunctionalComponentWithTheme extends FC {
  theme?: string;
}
type Props = AppProps & {
  Component: FunctionalComponentWithTheme;
};
function Application({
  Component,
  pageProps
}: Props) {
  return <FeatureFlagProvider flags={pageProps.featureFlags} data-sentry-element="FeatureFlagProvider" data-sentry-component="Application" data-sentry-source-file="_app.tsx">
      <SessionProviderWithFeatureFlag session={pageProps.session} data-sentry-element="SessionProviderWithFeatureFlag" data-sentry-source-file="_app.tsx">
        <ApplicationMetadata data-sentry-element="ApplicationMetadata" data-sentry-source-file="_app.tsx" />
        <ThemeProvider forcedTheme={Component.theme} themes={['child']} enableSystem={false} data-sentry-element="ThemeProvider" data-sentry-source-file="_app.tsx">
          <Component {...pageProps} data-sentry-element="Component" data-sentry-source-file="_app.tsx" />
        </ThemeProvider>
        <Script src="/peach/peach-collector-1.4.1.min.js" onLoad={() => {
        PeachCollectorLoaded();
      }} data-sentry-element="Script" data-sentry-source-file="_app.tsx" />
      </SessionProviderWithFeatureFlag>
    </FeatureFlagProvider>;
}
export default Application;